<!--suppress ALL -->
<template>
  <div class="flex flex-col">
    <eezee-nav />
    <z-loading :active="isLoading" :is-full-page="true" />

    <!--    Error    -->
    <div
        v-if="$store.state.queryIdInfoResult === 'error'"
        class="flex flex-col justify-center text-center gap-2 h-85 relative overflow-hidden z-10"
        :style="this.isEezeeTheme ? `color: black` : `color: #001136`">
      <p class="font-bold text-2xl m-9">{{ $t('AnErrorOccurred') }}</p>
      <div
          v-if="this.isEezeeTheme"
          :style="$i18n.locale === 'ar' ? `left:-50%;` : `right:-50%;`"
          class="h-full w-full absolute top-1/2 -z-1">
        <Circles color="yellow" />
      </div>
    </div>

    <div v-else>
      <div class="flex flex-col justify-center text-center gap-2 m-9">
        <p v-if="$store?.state?.queryIdInfoResult?.status === 'Active'" class="font-bold text-2xl whitespace-pre">{{ this.isEezeeTheme ? $t('LineIsActive') : $t('LineIsActive') }}</p>
        <p v-else class="font-bold text-2xl text-center" :style="this.isEezeeTheme ? 'color: black' : 'color: #001136'">{{ this.isEezeeTheme ? $t('EezeeHeader') : $t('RbHeader') }}</p>
        <p class="text-eezeeGray">{{ $t('EezeeSubHeader') }}</p>
      </div>
      <div :style="this.isEezeeTheme ? `backgroundColor: #80b626;` : `backgroundColor: #001136;`">
      <div
          class="p-7 z-20 relative overflow-hidden">
        <div class="flex flex-row justify-between" :style="this.isEezeeTheme ? `color: #004a41` : `color: white`">
          <div class="font-extrabold grid-item">
            <img
                v-if="isEezeeTheme"
                src="../../assets/eezee.svg"
                alt="eezee logo"
                class="h-8 sm:h-12" />
            <img
                v-else
                src="../../assets/RedBullLogo.svg"
                alt="eezee logo"
                class="h-9" />
            {{ $t('EezeePrepaid') }}
          </div>
          <div class="font-semibold">
            {{ $t('YourNumber') }}
            <p class="font-bold text-2xl">
              {{ $store.state.queryIdInfoResult.msisdn }}
            </p>
          </div>
        </div>

        <div class="rounded-t-xl w-full mt-7" :style="this.isEezeeTheme ? `backgroundColor: rgba(255, 255, 255, 0.75); color: #004a41` : `backgroundColor: white; color: #001136`">
          <div v-for="benefit in $store?.state?.eezeePlanInfoResult" :key="benefit.id">
            <div v-if="benefit.label_en.includes('Internet')" class="flex flex-col p-4">
              <p>
                {{
                  $t('Internet', {
                    network: benefit.value
                  })
                }}
              </p>
              <p class="font-semibold text-lg">
                {{
                  $t('GbAndMore', { limit: benefit.value.match(/\d+/)[0] })
                }}
              </p>
            </div>
            <div v-if="benefit.label_en.includes('Validity')"
                 class="flex flex-row justify-between p-4"
                 :style="isEezeeTheme ? `backgroundColor: rgba(128, 182, 38, 0.5)` : `borderTopWidth: 1px;`"
            >
              <p class="font-bold">{{ $t('Benefits') }}</p>
              <p class="text-sm">
                {{
                  $t('PlanIsValidFor', {
                    days: benefit.value
                  })
                }}
              </p>
            </div>
          </div>
        </div>

        <div v-for="(benefit, index)  in chunkCommonBenefits" :key="benefit.id" class="flex flex-row bg-white"
             :style="index === chunkCommonBenefits.length - 1
           ?  isEezeeTheme ? `border-bottom-width: 0px; border-bottom-right-radius: 12px; border-bottom-left-radius: 12px; border-color: #80b626` : `border-bottom-width: 0px; border-bottom-right-radius: 12px; border-bottom-left-radius: 12px; border-color: #E6E7E8`
           : isEezeeTheme ? `border-bottom-width: 0.031rem; border-color: #80b626` : `border-bottom-width: 0.031rem; border-color: #E6E7E8`"
        >
          <div :style="benefit.length % 2 === 0 ?  $i18n.locale === 'ar'
                      ? isEezeeTheme ? `border-left-width: 0.031rem; border-color: #80b626` : `border-left-width: 0.031rem; border-color: #E6E7E8`
                      : isEezeeTheme ? `border-right-width: 0.031rem; border-color: #80b626` : `border-right-width: 0.031rem; border-color: #E6E7E8`
                      : ''
                  "
               class="flex flex-1 gap-2.5 flex-row py-4 justify-center items-center p-2">
            <img
                :src="'https://channels-cms.zcloud.kw.zain.com' + benefit[0]?.icon?.data?.attributes?.url"
                alt="phone logo"
                class="h-6 sm:h-12"/>
            <div :style="isEezeeTheme ? `color: #004a41` : `color: #001136`">
              <p class="font-bold text-lg">
                {{ benefit[0]?.value.toLowerCase() === 'unlimited' && $i18n.locale === 'ar' ? 'بلا حدود' : benefit[0]?.value }}
              </p>
              <p class="text-sm">{{
                  $i18n.locale === 'ar'
                      ? benefit[0].label_ar
                      : benefit[0].label_en
                }}
              </p>
            </div>
          </div>
          <div v-if="benefit.length === 2" class="flex flex-1 gap-2.5 flex-row py-4 justify-center  p-2 items-center" :style="isEezeeTheme ? `color: #004a41` : `color: #001136`">
            <img
                :src="'https://channels-cms.zcloud.kw.zain.com' + benefit[1]?.icon?.data?.attributes?.url"
                alt="phone logo"
                class="h-6 sm:h-12"/>
            <div>
              <p class="font-bold text-lg">
                {{ benefit[1]?.value?.toLowerCase() === 'unlimited' && $i18n.locale === 'ar' ? 'بلا حدود' : benefit[1]?.value }}
              </p>
              <p class="text-sm">{{
                  $i18n.locale === 'ar'
                      ? benefit[1]?.label_ar
                      : benefit[1]?.label_en
                }}
              </p>
            </div>
          </div>
        </div>

        <div class="my-4 flex flex-col ml-2" v-if="!($store?.state?.queryIdInfoResult?.status === 'Active' || $store?.state?.queryIdInfoResult?.status === 'Pending')">
          <p class="text-xs mb-2" :style="this.isEezeeTheme ? `color: black` : `color: white`">
            {{ $t('EezeeTerms') }}
          </p>

          <div class="flex flex-row" >
            <z-check-box size="sm" :rounded="false" color="primary"  v-model="termsAccepted" :style="$i18n.locale === 'ar' ? `margin-left: 4px` : `margin-right: 4px`" />
            <p class="text-black text-xs mt-1" :style="this.isEezeeTheme ? `color: black` : `color: white`">
              {{ $t('EezeeAgreeTerms') }}
              <a
                  :href="isEezeeTheme ? `https://www.kw.zain.com/${$i18n.locale}/shop/terms-conditions` : `https://redbullmobile.kw.zain.com/${$i18n.locale}/terms-and-conditions`"
                  target="_blank"
                  class="font-bold underline"
                  :style="isEezeeTheme ? `color: #d12b8a` : `color: #DB0A40`">
                {{ $t('TermsAndConditions') }}
              </a>
            </p>
          </div>
        </div>
        <div class="mt-4 py-4 text-center items-center rounded-xl"
             :style="
                  termsAccepted || ($store?.state?.queryIdInfoResult?.status === 'Active' || $store?.state?.queryIdInfoResult?.status === 'Pending')
                    ? `color: white; background-color: ${isEezeeTheme ? `#D12B8A` : `#DB0A40`}`
                    : `color: #A3A3A3; background-color: #E5E5E5`"
        >
          <p v-if="$store.state.queryIdInfoResult.status === 'Pending'"
             class="font-extrabold text-2xl">
            {{ $t('ActivationInProgress') }}
          </p>
          <p
              v-else-if="$store.state.queryIdInfoResult.status === 'Active'"
              class="font-extrabold text-2xl">
            {{ $t('LineIsActive') }}
          </p>
          <button
              v-else
              :disabled="!termsAccepted"
              @click="$store.state.isPollingPaci = true"
              class="font-extrabold text-2xl underline">
            {{ this.isFreeTrial ? $t('ActivateYourLineForFree') : $t('ActivateYourLine') }}
          </button>
          <ZBottomSheet v-model="$store.state.isPollingPaci">
            <EezeeVerification />
          </ZBottomSheet>
        </div>
        <div v-if="this.isEezeeTheme"
             :style="$i18n.locale === 'ar' ? `left:-50%;` : `right:-50%;`"
             class="h-full w-full absolute top-1/2 -z-1">
          <Circles color="yellow" />
        </div>
      </div>
          <img
              v-if="!isEezeeTheme"
              src="../../assets/RedBullPattern.svg"
              alt="RedBull Ptatern"
              class="h-full absolute w-full z-10 opacity-30"
              :style="$i18n.locale === 'ar' ? 'transform: scaleX(-1); top: 12%' : 'top: 12%'"
          />
      </div>
    </div>
      <img
          v-if="!isEezeeTheme"
          src="../../assets/RedBullPattern.svg"
          alt="RedBull Pattern"
          class="absolute w-full -z-1 opacity-60"
          :style="$i18n.locale === 'ar' ? 'transform: scaleX(-1); top: 28%' : 'top: 28%'"
      />
  </div>
</template>

<script>
import EezeeNav from '@/components/eezee/EezeeNav.vue'
import ZBottomSheet from '@/components/ZBottomSheet.vue'
import Circles from '@/assets/Circles.vue'
import EezeeVerification from '@/components/eezee/EezeeVerification.vue'
import ZLoading from '@/zain-component-library/src/lib-components/ZLoading.vue'
import ZCheckBox from "../../zain-component-library/src/lib-components/ZCheckBox.vue";

export default {
  name: 'HomeEezee',
  components: {
    ZCheckBox,
    ZLoading,
    EezeeVerification,
    EezeeNav,
    Circles,
    ZBottomSheet
  },
  created() {
    this.fetchPlanInfo()
  },
  methods: {
    async fetchPlanInfo() {
      this.isLoading = true
      const result = await this.$store.state.eezeePlanInfoResult
      if(result === 'error') {
        this.isLoading = false
      } else {
        const nonCommonBenefits = JSON.parse(JSON.stringify(result)).filter((benefit => !benefit.label_en.includes('Validity')));
        for (let index = 0; index < nonCommonBenefits.length; index += 2) {
          this.chunkCommonBenefits.push(nonCommonBenefits.slice(index, index + 2))
        }
      }
      this.isLoading = false
    }
  },
  data() {
    return {
      termsAccepted: false,
      isLoading: false,
      chunkCommonBenefits: [],
      isEezeeTheme: this.$route.path.startsWith('/eezee'),
      isFreeTrial: this.$store.state.isFreeTrial
    }
  }
}
</script>
